




















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getDefaultAloForgottenPass } from '../models/alo/AloForgottenPass';
import * as rules from '@/utils/validationRules'
import { TemplateMail } from '@/enum/TemplateMail';
import { ApiUserRole } from '@/enum/ApiUserRole';

@Component({
  name: 'Login',  
})
export default class Login extends Vue {
    
  Password = ''
  Mail = ''  

  RegisPassword = ""
  RegisConfirmPassword = ""
  RegisMail = ""
  RegisNom = ""
  RegisType = "Particulier"

  typeAccount = [{label:'Un particulier',value:"Particulier"},
                {label:'Un MNS',value:"MNS"},
               /* {label:'Une piscine',value:"Piscine"}*/] 

  dirtyEmail = false
  dirtyPwd = false

  forgotpass = false
  loadingAuth = false
  loadingRegis = false
  
  get authStatus() {
    switch(this.$store.myGetters.authStatus){
      case "AuthenticationProgress":
        return this.$t('Login.AuthenticationProgress')
      case "AuthenticationSuccess":
        return this.$t('Login.AuthenticationSuccess')
      case "AuthenticationError":
        return this.$t('Login.AuthenticationError')     
      case "PassForgottenSuccess":
        return this.$t('Login.PassForgottenSuccess')  
      case "PassForgottenProgress":
        return this.$t('Login.PassForgottenProgress')  
      case "PassForgottenError":
        return this.$t('Login.PassForgottenError') 
      default:
        return ''        
    }
  }

  get registrationStatus() {
    switch(this.$store.myGetters.authStatus){
      case "RegistrationProgress":
        return this.$t('Login.RegistrationProgress')
      case "RegistrationSuccess":
        return this.$t('Login.RegistrationSuccess')
      case "RegistrationError":
        return this.$t('Login.RegistrationError')     
      default:
        return ''        
    }
  }

  get redirectPath(){
      return this.$store.myGetters.redirectPath
  }

  
  beforeDestroy() {

  }
  
  @Watch("dirtyEmail")
  dirtyEmailChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.UserName.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch("dirtyPwd")
  dirtyPwdChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.Password.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }
  
  mounted(){
    this.hackToSolveAutoFillIssue()  
    this.$store.myActions.AUTH_RESET_STATUS()
  }

  hackToSolveAutoFillIssue(){
    let times = 0;
    const interval = setInterval(() => {
      times += 1
      if ((this.dirtyEmail && this.dirtyPwd) || times === 30) {
        clearInterval(interval)
      }
      else{
        this.dirtyEmail = !!document.querySelector('input[name="UserName"]:-webkit-autofill')
        this.dirtyPwd = !!document.querySelector('input[name="Password"]:-webkit-autofill')
      }
    }, 100)
  }
    
  submit() {       
    if ((this.$refs.login as HTMLFormElement).validate()) {    
      this.loadingAuth = true   
      if(this.forgotpass){      
        this.$store.myActions.AUTH_PASSWORD_REQUEST({ 
          ...getDefaultAloForgottenPass(),
          userEmail:this.Mail
        }).finally(() => {
          this.loadingAuth = false
        })
      }
      else{      
        this.$store.myActions.AUTH_REQUEST({ userEmail:this.Mail, userPass:this.Password }).then(() => {                    
          this.$router.push(this.redirectPath)
        }).finally(() => {
          this.loadingAuth = false
        })
      }
    }
  }  

  submitRegis(){
    if ((this.$refs.registration as HTMLFormElement).validate()) {  
    this.loadingRegis = true    
      this.$store.myActions.AUTH_CREATE_ACCOUNT_REQUEST({ userEmail:this.RegisMail, userPass:this.RegisPassword, userNom:this.RegisNom, userNewPass:this.RegisConfirmPassword, userType:this.RegisType, mtpId:TemplateMail.CompteAjoute }).then(() => {                    
        this.$router.push(this.redirectPath)
      }).finally(() => {
        this.loadingRegis = false
      })
    }
  }  

  forgotpassword() {
    this.$store.myActions.AUTH_RESET_STATUS()
    this.forgotpass = !this.forgotpass
  }

   ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }    

  rulePasswordMinLength(v:string) {
    return rules.rulePasswordMinLength(v)
  }  

  rulePasswordMatch(v:string) {
    return rules.rulePasswordMatch(v,this.RegisPassword)
  }  
  
   ruleMailValid(v:string) {
    return rules.ruleMailValid(v)
  }   
}
